<template>
  <div>
    <vs-dialog blur v-model="qosic_dialog">
      <template #header>
        <h4 class="not-margin">Confirmation Depot</h4>
        <v-alert v-model="momopay_flooz_alert" dismissible color="warning">
          <span class="mb-3 font-weight-bold" style="ponter:cursor;">NOTIFICATION NON RECUE<br /></span>
          Les notifications de paiement peuvent prendre 5 à 15 secondes avant de s'afficher sur votre telephone <br>
          donc veuillez patienter jusqu'à 15 secondes et si vous ne recevez toujours pas de notification, <br>
          <span class="font-weight-bold" style="font-size: 2em;">tapez *155*27# </span>pour valider la transaction
      </v-alert>
      </template>
      <div class="con-form">
        <div class="center examplex">
          <vs-table striped>
            <template #tbody>
              <vs-tr>
                <vs-th> MOYEN DE PAIEMENT </vs-th>
                <vs-th> <vs-select placeholder="Select" v-model="type">
                    <vs-option label="FLOOZ" value="FLOOZ">
                      <vs-avatar size="20">
                        <img src="/img/moov.jpg" alt="">
                      </vs-avatar>
                      FLOOZ
                    </vs-option>
                    <vs-option label="TMONEY" value="TMONEY">
                      <vs-avatar size="20">
                        <img src="/img/tmoney.png" alt="">
                      </vs-avatar>
                      TMONEY
                    </vs-option>
                  </vs-select>
                </vs-th>
              </vs-tr>
              <vs-tr>
                <vs-th> MONTANT </vs-th>
                <vs-th style="font-size: 1.5em">{{ montant }} </vs-th>
              </vs-tr>
              <vs-tr>
                <vs-th> NUMERO sans indicatif </vs-th>
                <vs-th><vs-input type="number" v-model="phone_number" placeholder="Numero sans indicatif"
                    style="font-size: 1.7em" /> </vs-th>
              </vs-tr>

            </template>
          </vs-table>
        </div>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block @click="paygate">
            Deposer
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<script>
import firebase from '../../fb'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
export default {
  props: {
    amount: String,
    moyen: String,
  },
  data() {
    return {
      qosic_dialog: false,
      momopay_flooz_alert: false,
      otp: '',
      phone_number: '',
      type: '',
      bf_dialog: false
    }
  },
  computed: {
    montant() {
      return this.amount
    },
  },

  watch: {
    type(newValue, oldValue) {
      console.log(newValue);
    }
  },
  mounted() {
    this.$root.$on('paygate_paiement', () => {
      this.qosic_dialog = true
      this.type = this.moyen.toUpperCase()
    });
  },

  methods: {
    showMoovAlert(){
      if (this.type == 'FLOOZ') {
        this.momopay_flooz_alert = true
        setTimeout(() => {
          this.momopay_flooz_alert = false;
        }, 30000);
      }
    },
    async paygate() {
      if (this.phone_number.length !== 8) {
        alert('veuillez saisir un numeero a 8 chiffres')
        return
      }
      if (this.type.length < 3) {
        alert('veuillez selectionner un moyen de paiement')
        return
      }

      if (this.montant < 500) {
        alert('montant minimum de depot est de 500 fr')
        return
      }

      const loading = this.$vs.loading()
      let user = firebase.auth().currentUser
      let moyen = this.type
      let payload = {
        "amount": `${this.montant}`,
        "description": "deposit",
        "phone_number": `${this.phone_number}`,
        "network": moyen,
        moyen,
        "user_id": user.uid
      }
      console.log(payload);

      let base_url = this.base_url
      if (location.hostname === "localhost") {
        base_url = 'http://localhost:4000'
      }
      let urlPath = 'payment/deposit'
      //let url = base_url + '/paygate/paygate_payment'
      let url = `${base_url}/${urlPath}`
      let auth_token = await this.firebase_auth_token()

      setTimeout(() => {
        loading.close()
      }, 15000);

      axios.post(url, payload, auth_token).then(res => {
        loading.close()
        let {data} = res
        console.log(data);
        this.qosic_dialog = false
        let message
        let title
        let type
        if (data.tx_reference !== undefined && data.status !== undefined) {
          console.log('paygate response');
          let { status, tx_reference } = res.data
          if (status == 0 || tx_reference > 0) {
            swal('Dépot en cours', 'Veuillez confirmer sur votre telephone', "success", { button: "ok" });
           
          }
          else {
            swal('Error', 'Erreur veuillez verifier vos données et reessayer', "error", { button: "ok" });
          }
          return
        }

        if (data.tx_reference == undefined) {
          console.log('not paygate');
          switch (res.data) {
          case 'success': title = 'Paiement initié'; message = 'Veuillez confirmer sur votre telephone'; type = 'success'; 
            break;
            case 'Pending validation payment found' : title = 'Paiement deja initié'; message = 'Veuillez confirmer sur votre telephone'; type = 'success'
            break;
          case 'error': title = 'Oups!! Paiement echoué'; message = 'Erreur veuillez verifier vos données et reessayer'; type = 'error'
            break;
          case 'otp invalid': title = 'Oups!! OTP invalide'; message = 'Veuillez entrer un code OTP valid'; type = 'error'
            break;
          default:
            break;
        }
        swal(title, message, type, { button: "ok" });
        }
      }).catch(e => {
        console.log(e);
        swal('Error', 'Erreur veuillez verifier vos données et reessayer', "error", { button: "ok" });
      })

    },
  },

}
</script>

<style lang="scss" scoped></style>